import { findLastIndexAtOrBefore } from "./find-last-at-or-before.js";
//#region src/array/find-range-at.ts
/** Finds the ordered range containing the target value. */
function findRangeAt(ranges, value, getStart, getEnd) {
	const index = findLastIndexAtOrBefore(ranges, value, getStart);
	if (index < 0) return void 0;
	const range = ranges[index];
	const end = getEnd(range);
	const last = index === ranges.length - 1;
	return value < end || last && value === end ? range : void 0;
}
//#endregion
export { findRangeAt };

//# sourceMappingURL=find-range-at.js.map